// Tap BPM (SPEC F6): 4+ taps, median interval, half and double, resets after 2 s idle.

export const MIN_TAPS = 4;
export const IDLE_MS = 2000;

/** Adds a tap (timestamp in ms). A gap over 2 s starts over with this tap. */
export function addTap(taps: readonly number[], t: number): number[] {
  const last = taps[taps.length - 1];
  return last !== undefined && t - last > IDLE_MS ? [t] : [...taps, t];
}

/** BPM from the median interval, or undefined with fewer than 4 taps. */
export function bpmFromTaps(taps: readonly number[]): number | undefined {
  if (taps.length < MIN_TAPS) return undefined;
  const gaps = taps.slice(1).map((t, i) => t - (taps[i] as number)).sort((a, b) => a - b);
  const mid = Math.floor(gaps.length / 2);
  const median = gaps.length % 2 ? (gaps[mid] as number) : ((gaps[mid - 1] as number) + (gaps[mid] as number)) / 2;
  return median > 0 ? Math.round(60000 / median) : undefined;
}

export const halve = (bpm: number): number => Math.round(bpm / 2);
export const double = (bpm: number): number => Math.round(bpm * 2);
